$('.js-more').on('click', function(e) {
	e.preventDefault();
	$(this).toggleClass('toggled');
	$('.js-toggle-container').slideToggle();

	if ($(this).hasClass('toggled')) {
		$(this)
			.find('.btn-read__more')
			.addClass('hidden')
			.siblings()
			.removeClass('hidden');
	} else {
		$(this)
			.find('.btn-read__more')
			.removeClass('hidden')
			.siblings()
			.addClass('hidden');
	}
});
